import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import BusinessCard from "@/components/BusinessCard";
import { Loader2, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/favorites").then(({ data }) => setItems(data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
      <h1 className="font-display text-3xl font-extrabold text-sam-navy flex items-center gap-2 mb-6"><Heart className="h-7 w-7 text-sam-crimson fill-sam-crimson" />Saved Businesses</h1>
      {loading ? <div className="h-48 grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-sam-crimson" /></div>
        : items.length === 0 ? (
          <div className="rounded-xl border border-dashed p-12 text-center">
            <p className="font-display text-lg text-sam-navy">No saved businesses yet.</p>
            <Button className="mt-4 bg-sam-navy" asChild><Link to="/browse">Browse the directory</Link></Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">{items.map((b, i) => <BusinessCard key={b.id} b={b} index={i} />)}</div>
        )}
    </div>
  );
}
